import type { FormikProps } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { BranchTypeFormInputs } from '../../branchesPanel/branchDetails/BranchTypeFormInputs'
import type { BranchCreationInput } from '../types'

type Props = {
  state: FormikProps<BranchCreationInput>
}
export const TypesDefinitionStep = ({ state: { values } }: Props) => {
  const translate = useTranslate()

  return (
    <>
      <p>{translate('branchCreationWizard.typesDefinitionStep.description')}</p>
      <BranchTypeFormInputs isRequired={!values.baseBranch} />
    </>
  )
}
